import type { ProxyJob } from './mockProxyJobs';
import { SOLICITOR_CONTACT_LIST } from './proxySolicitorContacts';
import { OUTREACH_KIND } from '../utils/proxyFollowUpTracker';

export interface FallbackSolicitor { name: string; email: string; }

// ICT-3 only: solicitors to try when a contest has no known dissident/solicitor
// contact. Never used for any other outreach.
export const FALLBACK_SOLICITORS: FallbackSolicitor[] = [
  { name: 'Saratoga Proxy Consulting', email: 'intake@saratogaproxy.com' },
  { name: 'Investorcom', email: 'contests@investorcom.com' },
  { name: 'Okapi Partners', email: 'contests@okapipartners.com' },
  { name: 'Innisfree M&A Incorporated', email: 'contests@innisfreema.com' },
  { name: 'Campaign Management', email: 'contests@campaignmgmt.com' },
];

export interface OutreachContact {
  name: string;
  email: string;
  source: 'contact_list' | 'prior_follow_up' | 'prior_year';
}

// Where Ace sends external outreach:
//   1. the job's solicitor, looked up on the Solicitor Contact List;
//   2. otherwise whoever the job was last followed up with (ICT-1: "If there
//      are previous follow ups on the job in MIC, continue following up to
//      that party");
//   3. otherwise the solicitor who handled last year's job (ICT-1: ask "Are
//      you handling the job this year?");
//   4. otherwise nobody — the job needs contact tracing (MISSING_CONTACT_ROUTE),
//      and Ace drafts no external email.
export function resolveOutreachContact(job: ProxyJob): OutreachContact | null {
  const listed = job.solicitor ? SOLICITOR_CONTACT_LIST[job.solicitor] : undefined;
  if (job.solicitor && listed) return { name: job.solicitor, email: listed, source: 'contact_list' };
  const prior = [...job.followUpHistory].reverse().find(r => OUTREACH_KIND[r.type]);
  if (prior) return { name: job.solicitor || job.priorYearSolicitor || job.issuer, email: prior.recipientEmail, source: 'prior_follow_up' };
  const lastYear = job.priorYearSolicitor ? SOLICITOR_CONTACT_LIST[job.priorYearSolicitor] : undefined;
  if (job.priorYearSolicitor && lastYear) return { name: job.priorYearSolicitor, email: lastYear, source: 'prior_year' };
  return null;
}

export function contactNote(contact: OutreachContact): string | undefined {
  if (contact.source === 'prior_follow_up') return 'last party followed up on this job';
  if (contact.source === 'prior_year') return 'handled last year\'s job';
  return undefined;
}
